import React from 'react';

export const HorizontalScroller: React.FunctionComponent<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ children, ...rest }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const requestedFinalScroll = React.useRef<number>(0);

  const onWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation(); // prevent default scroll behavior
    if (!ref.current) return;
    requestAnimationFrame(() => {
      const totalDelta = requestedFinalScroll.current - ref.current.scrollLeft + event.deltaY;

      requestedFinalScroll.current = Math.max(
        Math.min(
          ref.current.scrollLeft + totalDelta,
          ref.current.scrollWidth - ref.current.clientWidth
        ),
        0
      );

      // IF shift key is pressed, scroll will be done automatically by browser in a better way
      if (event.shiftKey) return;

      ref.current?.scrollBy({
        left: totalDelta,
        behavior: 'auto',
      });
    });
  };

  return (
    <div {...rest} ref={ref} onWheel={onWheel}>
      {children}
    </div>
  );
};
